import React from "react";
import { motion } from "framer-motion";
import { RotateCcw, Loader2 } from "lucide-react";

interface ReloadButtonProps {
  onReload: () => void;
  disabled?: boolean;
  loading?: boolean;
}

const ReloadButton: React.FC<ReloadButtonProps> = ({
  onReload,
  disabled = false,
  loading = false,
}) => {
  const isDisabled = disabled || loading;

  return (
    <motion.button
      disabled={isDisabled}
      onClick={!isDisabled ? onReload : undefined}
      className={`
        flex items-center justify-center w-11 h-11 rounded-xl transition-all duration-200 group
        ${
          isDisabled
            ? "bg-gray-100 text-gray-400 cursor-not-allowed border border-gray-200"
            : "hover:bg-blue-50 text-gray-700 hover:text-blue-600 hover:border-blue-200 border border-transparent cursor-pointer"
        }
      `}
      whileHover={!isDisabled ? { scale: 1.02 } : {}}
      whileTap={!isDisabled ? { scale: 0.98, rotate: 180 } : {}}
      title={
        isDisabled
          ? loading
            ? "Loading..."
            : "Reload disabled"
          : "Reload data"
      }
    >
      {loading ? (
        <Loader2 className="w-5 h-5 animate-spin" />
      ) : (
        <RotateCcw
          className={`
            w-5 h-5 transition-transform duration-300
            ${!isDisabled ? "group-active:rotate-180" : ""}
            ${loading ? "animate-spin" : ""}
          `}
        />
      )}
    </motion.button>
  );
};

export default ReloadButton;
